import React from 'react'
import PropTypes from 'prop-types'
import styled, { useTheme } from 'styled-components'

const LoadingContainerDiv = styled.div`
  position: ${props => (props.isFixed ? 'fixed' : 'relative')};
  top: ${props => (props.isFixed ? '0' : 'unset')};
  left: ${props => (props.isFixed ? '0' : 'unset')};
  width: 100%;
  height: ${props => (props.isFullScreen ? '100%' : '')};
  ${props => (props.isFullScreen ? 'min-height: 400px' : '')}
  background: ${props => (props.hasBackground ? 'rgb(36 54 70 / 0.45)' : '')};
  z-index: ${props => (props.hasBackground ? '1000' : 'unset')};
  &.small {
    min-height: 60px;
    margin-bottom: 20px;
  }
`

const LoadingSpinner = ({
  isSmall,
  isFixed,
  isGray,
  isFullScreen,
  hasBackground
}) => {
  const theme = useTheme()

  return (
    <LoadingContainerDiv
      isFixed={isFixed}
      isFullScreen={isFullScreen}
      hasBackground={hasBackground}
      className={
        isFullScreen
          ? `loading-container${isSmall ? ' small' : ''}`
          : isSmall
          ? ' small'
          : ''
      }
    >
      <div className={`loading ${isGray ? 'gray' : ''}`}></div>
    </LoadingContainerDiv>
  )
}

LoadingSpinner.defaultProps = {
  isSmall: false,
  isFixed: false,
  isGray: false,
  isFullScreen: true,
  hasBackground: false
}

LoadingSpinner.propTypes = {
  isSmall: PropTypes.bool,
  isFixed: PropTypes.bool,
  isGray: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  hasBackground: PropTypes.bool
}

export default LoadingSpinner
